<template>
	<v-card>
		<v-card-title class="header-modal">
			<span>Detalle del Asiento - Código: {{ dataSeat.code }}</span>
			<close-icon class="cursor-pointer" @click="$emit('close')"></close-icon>
		</v-card-title>
		<v-divider></v-divider>
		<v-card-text m-0 p-0>
			<v-layout wrap>
				<v-flex xs12 mb-2>
					<v-layout wrap>
						<v-flex xs4>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Fecha</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{ dataSeat.date | exactDate }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs4>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Asiento</v-flex>
								<v-flex xs6 pa-1 class="content-text">
									<span>{{ dataSeat.code }}</span>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs4>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Origen</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{ dataSeat && dataSeat.typeRegister ? dataSeat.typeRegister.name : '' }}</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 mb-2>
					<v-layout wrap>
						<v-flex xs12>
							<v-layout>
								<v-flex xs3 pa-1 class="content-label">Detalle</v-flex>
								<v-flex xs9 pa-1 class="content-text">
									<span>{{ dataSeat.gloss }}</span>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs6>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Cta. Contable</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{ Object.keys(rowDetail).length ? rowDetail.accountingAccount.name : '' }}</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs6>
							<v-layout>
								<v-flex xs6 pa-1 class="content-label">Referencia</v-flex>
								<v-flex xs6 pa-1 class="content-text">{{ Object.keys(rowDetail).length ? rowDetail.reference : '' }}</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<!-- Formulario para agregar un nuevo detalle al asiento -->
			<v-layout wrap v-if="openDetailSeat">
				<v-flex xs12 class="title-heading pt-1">
					Detalles
				</v-flex>
				<v-flex xs12 class="body-seat-form">
					<v-layout row wrap align-start>
						<v-flex xs8>
							<v-layout row wrap align-end>
								<v-flex xs6 pr-2>
									<v-select
										:items="accounts"
										item-text="fullName"
										item-value="id"
										solo
										autocomplete
										hide-details
										class="filter-select shadow-inset select-autocomplete-create"
										v-model="modelDetail.accountingAccountId"
										return-object
										@input="setData">
									</v-select>
								</v-flex>
								<v-flex xs6>
									<app-input-text
										disabled
										readonly
										:text="accountingAccount.name"/>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs4 pl-2>
							<app-input-text
								model="reference"
								placeholder="Referencia"
								:text="modelDetail.reference"
								@input="setModelData"
							></app-input-text>
						</v-flex>
						<v-flex xs4 pr-2>
							<app-input-text
								model="concept"
								placeholder="Concepto"
								:text="modelDetail.concept"
								@input="setModelData"
							></app-input-text>
						</v-flex>
						<v-flex xs4>
							<autocomplete-component
								append-icon="expand_more"
								http-code="$http"
								:item="modelDetail.costCenterId"
								item-text="name"
								item-value="id"
								:items="costCenters"
								model="costCenterId"
								placeholder-value="Centro de costos"
								prop="name"
								autocomplete
								prop-search="name"
								:disabled="validCostCenter"
								:resource-url="`cost-center/${params.subsidiaryId}/subsidiary`"
								return-object
								select-create
								@return-data="setCostCenter"
							></autocomplete-component>
						</v-flex>
						<v-flex xs3 pl-2>
							<app-input-text
								model="amount"
								placeholder="Importe"
								:text="modelDetail.amount"
								tooltip-message="Ingresar el importe con signo negativo (-) para crear detalles de tipo HABER"
								tooltip-on-focused
								type="number"
								@input="setModelData"
							></app-input-text>
							<span
								v-if="modelDetail.amount !== 0"
								:class="`${modelDetail.amount < 0 ? 'error' : 'secondary'}--text caption`">
								Detalle de tipo {{ typeDetail }}
							</span>
						</v-flex>
						<v-flex xs1 text-xs-center pt-2>
							<v-tooltip top>
								<button
									class="btn-create-seat"
									slot="activator"
									type="button"
									:disabled="validFields || validInsertCostCenter"
									@click="saveNewDetailSeat"
								>
									<v-icon color="secondary" size="26">add_circle</v-icon>
								</button>
								<span v-if="validFields">Completar todos los campos</span>
								<span v-else-if="validInsertCostCenter">Debe escoger un centro de costo</span>
								<span v-else>Agregar</span>
							</v-tooltip>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
			<!-- ? se quieto las siguientes linea en el componente no 
				? llegaba nada al otro lado solo las declaraba aqui 
				* :flag-number-account="flagValidNumberAccount"
				* :flag-valid="flagValidCostCenter" -->
			<journal-detail-list
				class="mt-3"
				:rows="details"
				:accounts="accounts"
				:cost-centers="costCenters"
				:flagDisabledAddSeat="false"
				:created-add="true"
				:code-journal="dataSeat.code"
				:settings="settings"
				:edit-detail-inline="editDetailInline"
				@click-icon="onClickIcon"
				@on-click="rowSelected"
				@add-detail="onAddDetail"
				@get-data="setDataDetail"
			></journal-detail-list>
			<journal-detail-balance
				:balance="balance"
				:credit="credit"
				:debit="debit"
			/>
		</v-card-text>
		<v-divider></v-divider>
		{{ isLoading }}
		{{ squareAmounts }}
		{{ !flagValidNumberAccount }}
		<v-card-actions>
			<div class="btn-actions">
				<v-tooltip top>
					<!-- ? se quito esta parte del disabled
						? del boton || !flagValidNumberAccount no tenia nada que ver -->
					<button
						slot="activator"
						class="btn-seat btn-save"
						:disabled="isLoading || squareAmounts"
						type="button"
						@click="saveAllDetailsEdits">
						Guardar
					</button>
					<span v-if="squareAmounts">Debe cuadrar el asiento para guardar</span>
					<span v-else>Guardar</span>
				</v-tooltip>
				<button
					class="btn-seat btn-clean"
					type="button"
					@click="$emit('close')"
				>
					Cancelar
				</button>
			</div>
		</v-card-actions>
		<v-dialog
			v-model="alertDelete"
			max-width="390"
			persistent>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">
					¿Desea eliminar el detalle del asiento?.
				</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn-seat btn-clean mr-2"
						@click="closeAlertDelete">
						No
					</button>
					<button
						type="button"
						class="btn-seat btn-save ml-2"
						@click="onDeleteDetail">
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import journalDetailBalance from '@/components/journal/journal-detail-balance';
	import journalDetailList from '@/components/journal/journal-detail-list';
	import appInputText from '@/components/autocomplete/app-input-text';
	import autocompleteComponent from '@/components/autocomplete/autocomplete-component';
	import closeIcon from '../../components/shared/icons/close.icon';

	function created() {
		this.details = this.dataSeat && this.dataSeat.details.length > 0 ? this.dataSeat.details : [];
		this.details = this.details.map((d) => {
			const newD = { ...d };
			newD.codeAccounting = this.accounts.find(a => a.id === d.accountingAccountId).account;
			return newD;
		});
		// this.credit = (this.dataSeat.totalHaber * -1);
		// this.debit = this.dataSeat.totalDebe;
		// this.balance = this.dataSeat.totalDebe - this.dataSeat.totalHaber;
		this.squareAmounts = this.validateAmountActions(this.details);
	}

	function rowSelected(row) {
		this.rowDetail = { ...row };
		this.details = this.details.map((d) => {
			const newRow = { ...d };
			newRow.isSelected = d.id === row.id;
			return newRow;
		});
	}

	function onAddDetail() {
		this.openDetailSeat = true;
		this.editDetailInline = false;
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
	}

	function onClickIcon({ action, row, index }) {
		this.indexRowDetail = index;
		this.editDetailInline = true;
		if (action === 'new-detail-seat') {
			this.openDetailSeat = false;
			this.modelDetail = { ...row };
			this.details = this.details.map((ds, indexD) => {
				const newDataSelected = { ...ds };
				newDataSelected.onEdit = indexD === this.indexRowDetail;
				return newDataSelected;
			});
			setTimeout(() => {
				const focusDetailEdit = document.getElementById('focus-edit-inline');
				focusDetailEdit.click();
			}, 1000);
			const firstDigit = row.accountingAccount.account.charAt(0);
			this.flagValidNumberAccount = (Number(firstDigit) < 4 || Number(firstDigit) > 8);
			if (this.flagValidNumberAccount) {
				this.modelDetail.costCenterId = null;
				this.details[index].costCenter = {};
				this.details[index].costCenterId = null;
				this.details[index].flagCostCenter = false;
			}
			if (this.settings.autoCenterCost) {
				if ((Number(firstDigit) < 4) && this.details[index].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && !this.details[index].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && this.details[index].costCenterId) {
					this.flagValidCostCenter = false;
				}
			}
		} else if (action === 'delete') {
			this.alertDelete = true;
		}
	}

	function setDataDetail({ model, value, row }) {
		this.modelDetail[model] = value;
		if (model === 'reference') {
			this.details[this.indexRowDetail].reference = value;
		}
		if (model === 'concept') {
			this.details[this.indexRowDetail].concept = value;
		}
		if (model === 'amount') {
			this.details[this.indexRowDetail].amount = value;
			const type = row.type === 1 ? 'Debe' : 'Haber';
			const newValue = row.type === 1 ? Number(value) : (Number(value) * -1);
			this.details[this.indexRowDetail][`amount${type}`] = newValue;
		}
		if (model === 'accountingAccount') {
			this.modelDetail.account = value.code;
			this.modelDetail.accountingAccountId = value.id;
			this.details[this.indexRowDetail].costCenter = value.id;
			this.details[this.indexRowDetail].accountingAccount = value;
			this.details[this.indexRowDetail].accountingAccountId = value.id;
			this.details[this.indexRowDetail].account = value.code;
			const firstDigit = value.account.charAt(0);
			this.flagValidNumberAccount = (Number(firstDigit) < 4 || Number(firstDigit) > 8);
			if (this.flagValidNumberAccount) {
				this.modelDetail.costCenterId = null;
				this.details[this.indexRowDetail].costCenter = {};
				this.details[this.indexRowDetail].costCenterId = null;
				this.details[this.indexRowDetail].flagCostCenter = false;
			}
			if (this.settings.autoCenterCost) {
				if ((Number(firstDigit) < 4) && this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && !this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = true;
				} else if ((Number(firstDigit) >= 4) && this.details[this.indexRowDetail].costCenterId) {
					this.flagValidCostCenter = false;
				}
			}
		}
		if (model === 'costCenter') {
			this.modelDetail.costCenterId = value.id;
			this.details[this.indexRowDetail].costCenter = value;
			this.details[this.indexRowDetail].costCenterId = value.id;
			this.details[this.indexRowDetail].flagCostCenter = false;
			this.flagValidCostCenter = false;
			this.flagValidNumberAccount = true;
		}
		this.balance = this.details.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
		this.squareAmounts = this.validateAmountActions(this.details);
	}

	function validateAmountActions(array) {
		this.debit = Number(array.reduce((sum, item) => sum + item.amountDebe, 0).toFixed(2));
		this.credit = Number((array.reduce((sum, item) => sum + item.amountHaber, 0) * -1).toFixed(2));
		const credit = Number(this.credit * -1);
		this.balance = this.debit - credit;
		return this.debit > credit || this.debit < credit;
	}

	async function saveAllDetailsEdits() {
		this.isLoading = true;
		const body = this.formatData(this.details);
		try {
			const { data: response } = await this.$http.patch(`accounting-seat-update-daily/${this.dataSeat.id}`, body);
			this.details = response.details;
			this.details = this.details.map((ds) => {
				const newDs = { ...ds };
				newDs.accountingAccount = this.accounts.find(a => a.id === ds.accountingAccountId);
				newDs.costCenterId = ds.costCenterId ? ds.costCenterId : null;
				newDs.costCenter = this.costCenters.find(cc => cc.id === ds.costCenterId);
				newDs.amount = ds.amountDebe > 0 ? ds.amountDebe : (ds.amountHaber * -1);
				return newDs;
			});
			this.debit = this.details.reduce((sum, item) => sum + item.amountDebe, 0);
			this.credit = (this.details.reduce((sum, item) => sum + item.amountHaber, 0) * -1);
			this.balance = response.totalDebe - response.totalHaber;
			this.showNotification('Detalles actualizados Correctamente');
			this.clearModels();
			this.$emit('close');
		} catch (error) {
			this.showGenericError();
		} finally {
			this.editDetailInline = false;
			this.openDetailSeat = false;
			this.isLoading = false;
			this.flagValidCostCenter = false;
			this.flagValidNumberAccount = false;
		}
	}

	function clearModels() {
		this.modelDetail = {
			accountingAccountId: null,
			account: null,
			concept: '',
			reference: '',
			costCenterId: null,
			amount: 0,
		};
	}

	function formatData(value) {
		const totalDebe = value.reduce((sum, item) => sum + item.amountDebe, 0);
		const totalHaber = value.reduce((sum, item) => sum + item.amountHaber, 0);
		const details = value.map((d) => {
			const newD = {};
			newD.id = d.id ? d.id : null;
			newD.type = d.type;
			newD.account = d.account || null;
			newD.concept = d.concept;
			newD.reference = d.reference;
			newD.amountDebe = Number(d.amountDebe);
			newD.amountHaber = Number(d.amountHaber);
			newD.costCenterId = d.costCenterId ? d.costCenterId : null;
			newD.accountingAccountId = d.accountingAccountId;
			newD.codeAccounting = this.accounts.find(a => a.id === d.accountingAccountId).account;
			return newD;
		});
		const newData = {
			totalDebe,
			totalHaber,
			clone: 2,
			details,
		};
		return newData;
	}

	function closeAlertDelete() {
		this.alertDelete = false;
	}

	function onDeleteDetail() {
		this.editDetailInline = true;
		this.details.splice(this.indexRowDetail, 1);
		this.indexRowDetail = null;
		this.squareAmounts = this.validateAmountActions(this.details);
		this.closeAlertDelete();
	}

	function setCostCenter(value) {
		this.costCenter = { ...value };
		this.modelDetail.costCenterId = value.id;
	}

	function setData(value) {
		this.accountingAccount = { ...value };
		this.modelDetail.account = value.code;
		this.modelDetail.accountingAccountId = value.id;
	}

	function setModelData({ model, value }) {
		if (model === 'date' || model === 'gloss') {
			this.model[model] = value;
		} else {
			this.modelDetail[model] = value;
		}
		this.balance = this.details.reduce((acc, item) => {
			const newAmount = Number(item.amount);
			return Number((acc + newAmount).toFixed(2));
		}, 0);
		if (this.settings.squareSeats) {
			if (this.balance === 0) {
				this.flagSquareSeats = false;
			} else {
				this.flagSquareSeats = true;
			}
		} else if (this.settings.squareSeats === false) {
			this.flagSquareSeats = false;
		}
	}

	async function saveNewDetailSeat() {
		const amount = Number(this.modelDetail.amount);
		const type = amount > 0 ? 'Debe' : 'Haber';
		this.modelDetail.type = amount > 0 ? 1 : 2;
		this.modelDetail.status = 1;
		this.modelDetail[`amount${type}`] = type === 'Debe' ? amount : (amount * -1);
		const otherType = type === 'Debe' ? 'Haber' : 'Debe';
		this.modelDetail[`amount${otherType}`] = 0;
		this.details.push({
			...this.modelDetail,
			accountingAccount: this.accountingAccount,
			costCenter: this.costCenter,
		});
		this.openDetailSeat = false;
		this.squareAmounts = this.validateAmountActions(this.details);
	}

	function validFields() {
		return !this.modelDetail.account || !this.modelDetail.accountingAccountId
		|| !this.modelDetail.amount	|| !this.modelDetail.concept
		|| !this.modelDetail.reference;
	}

	function validCostCenter() {
		let valid = false;
		if (this.modelDetail.account !== null) {
			const firstDigit = this.modelDetail.account.charAt(0);
			valid = (Number(firstDigit) < 4 && Number(firstDigit) > 8);
		}
		if (valid) {
			this.setCostCenter({});
		}
		return valid;
	}
	function validInsertCostCenter() {
		let valid = false;
		if (this.settings.autoCenterCost) {
			const firstDigit = this.modelDetail.account.charAt(0);
			if ((Number(firstDigit) >= 4 && Number(firstDigit <= 8)) && !this.modelDetail.costCenterId) {
				valid = true;
			}
		}
		return valid;
	}

	function typeDetail() {
		return this.modelDetail.amount < 0 ? 'HABER' : 'DEBE';
	}

	function data() {
		return {
			details: [],
			rowDetail: {},
			openDetailSeat: false,
			indexRowDetail: null,
			editDetailInline: false,
			flagValidNumberAccount: false,
			flagValidCostCenter: false,
			flagSquareSeats: false,
			modelDetail: {
				accountingAccountId: null,
				account: null,
				concept: '',
				reference: '',
				costCenterId: null,
				amount: 0,
			},
			credit: null,
			debit: null,
			balance: null,
			isLoading: false,
			squareAmounts: false,
			alertDelete: false,
			costCenter: {},
			accountingAccount: {},
		};
	}

	export default {
		name: 'preview-clone-seat',
		data,
		created,
		components: {
			closeIcon,
			journalDetailList,
			journalDetailBalance,
			appInputText,
			autocompleteComponent,
		},
		methods: {
			rowSelected,
			onAddDetail,
			onClickIcon,
			setDataDetail,
			validateAmountActions,
			saveAllDetailsEdits,
			formatData,
			clearModels,
			closeAlertDelete,
			onDeleteDetail,
			setCostCenter,
			setData,
			setModelData,
			saveNewDetailSeat,
		},
		computed: {
			validFields,
			validCostCenter,
			validInsertCostCenter,
			typeDetail,
		},
		props: {
			dataSeat: {
				type: Object,
				default: {},
			},
			accounts: {
				default: () => [],
				type: Array,
			},
			costCenters: {
				default: () => [],
				type: Array,
			},
			settings: {
				type: Object,
				default: {},
			},
			modules: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.content-label {
		color: #2c404a;
		background-color: #e0e5e8;
		font-family: map-get($fonts, AvenirRegular);
		font-size: 12px;
		font-weight: 500;
	}

	.content-text {
		background-color: white;
		font-family: map-get($fonts, AvenirRegular);
		font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/journal/preview-clone-seat.vue